import React from "react";
import { Link } from "react-router-dom";
import { Popover } from "antd";
import { Button, Card, Divider } from '@mui/material';

import { CONTEXT, API_ROOT, URL } from "../config";
import { passwordChange } from '../services/authService';
import { useTheme, useConfirmDialog } from "../hooks";
import Utils from "../utilities";


const Header = props => {
  const {name, mail, position, userPic } = props.loginData;
  const { isDarkMode } = useTheme();

  return (
    <div className="container-fluid position-fixed header-area">
      <div className="row align-items-center">
        <div className="col-6">
          <Link to={CONTEXT}>
            <img className="ml-1" style={{ width: "13rem" }} alt="Incedo Lighthouse Logo"
              src={isDarkMode ? `${URL}lighthouse-logo-white.png` : `${URL}lighthouse-logo-black.png`}
            />
          </Link>
        </div>
        <div className="col-6 d-flex">
          <div className="d-flex align-items-center ml-auto">
            <span className="text-capitalize fs14 mr-3">
              Hi, {name && name.split(" ")[0]}
            </span>
            <Popover
              placement="bottomRight"
              trigger="click"
              zIndex='1001'
              content={
                <Card>
                  <Logout
                    authUser={name}
                    userMail={mail}
                    userPosition={position}
                    userPic={userPic}
                    logout={props.resetLoggedIn}
                  />
                </Card>
              }>
              {userPic
                ? <img src={`data:image/jpeg;base64,${userPic}`} alt="user"
                    style={{ borderRadius: "2rem", height: "2rem", verticalAlign: "sub", }}
                  />
                : <div className="d-flex justify-content-center align-items-center rounded-circle cursor-pointer mr-2 profile-icon">
                    <span className="text-uppercase text-white">{name && name.split(" ").map((n) => n[0]).join("")}</span>
                  </div>
              }
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Logout = props => {
  const { isConfirmed } = useConfirmDialog();
  const hasRights = Utils.getUserRights();

  const handlePasswordChange = async () => {
    const confirmed = await isConfirmed('Are you sure you want to change password?');
    if(!confirmed){return;}
    passwordChange()
      .then(res => {
        let redirectURL = window.location.origin+URL;
        let changePasswordURL = `${API_ROOT}changePassword?token=${res.data.response}&redirect_uri=${redirectURL}${CONTEXT}`;
        Utils.setStoredValue('resp', '');
        window.location=changePasswordURL;
      })
  }

  return (
    <div className="container header-area py-3" style={{minWidth: `230px`}}>
      <div className="d-flex align-items-center">
        {props.userPic
          ? <img src={`data:image/jpeg;base64,${props.userPic}`} style={{ borderRadius: "2rem", height: "2rem", verticalAlign: "sub",}} alt="user" />
          : <div className="d-flex justify-content-center align-items-center rounded-circle cursor-pointer mr-2 profile-icon">
              <span className="text-uppercase text-white">{props.authUser && props.authUser.split(" ").map((n) => n[0]).join("")}</span>
            </div>
        }
        <h6 className="flex-gow-1 fs14 mb-0 text-capitalize text-primary-blue">
          {props.authUser}
          <span className="d-block text-muted fs12">{props.userPosition}</span>
        </h6>
      </div>
      <Divider className="my-3" />
      <div>
        <h6>
          <span className="d-block text-primary-blue fs12 mb-1">Email</span>
          <span className="d-block text-muted fs12">{props.userMail}</span>
        </h6>
        <h6>
          <span className="d-block text-primary-blue fs12 mb-1">Groups</span>
          <span className="d-block text-muted fs12">{hasRights.join(", ")}</span>
        </h6>
      </div>
      <Divider className="my-3" />
      <div><Button size="small" variant="text" className="w-100 mb-2" onClick={() => handlePasswordChange()}>Change Password</Button></div>
      <div><Button size="small" variant="outlined" className="w-100 bg-primary-blue text-white" onClick={() => props.logout()}>Logout</Button></div>
    </div>
  );
}

export default Header;